import { faker } from '@faker-js/faker';
import { cleanup } from '@testing-library/react';
import { HttpResponse, http } from 'msw';
import { setupServer } from 'msw/node';
import { vi } from 'vitest';

import constants from '../constants';
import redux from '../redux';
import translations from '../translations';

translations.init();

const customerServiceBase = 'https://cgs-api.test';

describe('customer group selector updating the current context', () => {
  // create a mock server
  const server = setupServer(
    http.put(`${customerServiceBase}${constants.endpoints.put.context}`, () => {
      return HttpResponse.json({
        customer_group_uuid: faker.string.uuid(),
        customer_uuid: faker.string.uuid(),
        enforce: 'customer_group',
        partner_uuid: faker.string.uuid(),
      });
    }),
  );

  beforeAll(() => {
    window.location = {
      ...window.location,
      reload: vi.fn(),
    };
    server.listen();
  });

  afterAll(() => {
    server.close();
  });

  afterEach(() => {
    server.resetHandlers();
    cleanup();
  });

  beforeEach(() => {
    redux.store.dispatch(redux.api.setCustomerServiceUrl(customerServiceBase));
  });

  it('should update the current context', async () => {
    redux.store.dispatch(
      redux.api.putContext({
        customer_group_uuid: faker.string.uuid(),
        customer_uuid: faker.string.uuid(),
      }),
    );

    await new Promise((resolve) => {
      setTimeout(resolve, 100);
    });

    expect(redux.store.getState().api.context).not.toBeUndefined();
    expect(redux.store.getState().api.context).not.toBeNull();
    expect(window.location.reload).toHaveBeenCalledTimes(1);
  });
});
